// src/components/marketing/CTAContainer.jsx
import React from "react";
import { Link } from "react-router-dom";

const CTAContainer = ({
  title = "",
  text = "",
  buttonText = "",
  buttonLink = "",
  secondaryButtonText = "",
  secondaryButtonLink = "",
}) => {
  return (
    <section className="relative left-1/2 right-1/2 w-screen -translate-x-1/2 bg-[#F6F4FA] py-20 px-5 my-24">
      <div className="mx-auto max-w-3xl text-center">
        {title && typeof title === "string" && (
          <h2 className="font-medium text-3xl text-purple-800 mb-4">
            {String(title)}
          </h2>
        )}

        {text && typeof text === "string" && (
          <p className="text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
            {String(text)}
          </p>
        )}

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          {buttonText && buttonLink && (
            <Link
              to={buttonLink}
              onClick={() => window.scrollTo(0, 0)}
              className="inline-block bg-purple-600 text-white font-semibold text-base px-10 py-4 rounded-lg no-underline tracking-wider transition-all duration-250 hover:bg-purple-700 hover:shadow-lg hover:-translate-y-0.5"
            >
              {buttonText}
            </Link>
          )}

          {secondaryButtonText && secondaryButtonLink && (
            <Link
              to={secondaryButtonLink}
              onClick={() => window.scrollTo(0, 0)}
              className="inline-block bg-transparent text-purple-700 font-semibold text-base px-10 py-4 rounded-lg no-underline tracking-wider border-2 border-purple-400 transition-all duration-250 hover:border-purple-600 hover:shadow-md hover:-translate-y-0.5"
            >
              {secondaryButtonText}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTAContainer;
